export default "__VITE_ASSET__Ssat$KHv__"